module.exports = __webpack_public_path__ + "static/media/bathing.c5cc6106.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard/bathing.svg
// module id = 322
// module chunks = 31